module.exports = __webpack_public_path__ + "img/move23.0ed57986.jpg";